import { backendApi } from "@/services/api";
import { ProcedureType } from "@/services/backend/types";

const procedureSwitchApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    switchProcedure: build.mutation<SwitchResponse, SwitchRequest>({
      query: (request) => ({
        url: `/inspections/procedures/switches`,
        method: "POST",
        body: request,
      }),
      invalidatesTags: (_result, error) =>
        error ? [] : ["Procedures", "SampleSet", "SampleSetDetail", "Process"],
    }),
  }),
});

export const { useSwitchProcedureMutation } = procedureSwitchApi;

export interface SwitchRequest {
  sampleSetId: string;
  toProcedureType: ProcedureType;
  reason: string;
  createdBy: string;
}

export interface SwitchResponse {
  newSampleSetId: string;
}
